<template>
    <b-modal
        id="signout-student-modal"
        v-model="modal"
        ref="signout-student-modal"
        size="md"
        :title="$t('internship.unsubscribe_student')"
        modal-class="apprentice-default-modal signout-student-modal"
        :ok-title="$t('internship.unsubscribe')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="signout()">
        <form>
            <b-form-group
                class="internship-rejection-letter"
                label-for="internship-rejection-letter-input"
                label="motivatie">
                <b-form-input
                    id="internship-rejection-letter"
                    v-model="signoutLetter"
                    placeholder="U bent uitgeschreven om de volgende reden">
                </b-form-input>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-internship-edit-enrolled-students-tab-signout-modal-component',
    emits: ['signout'],
    props: {
        internshipIn: Object,
    },
    data() {
        return {
            signoutLetter: '',
            modal: false,
            studentId: '',
        };
    },
    methods: {
        show(studentId) {
            if (!this.modal) {
                this.modal = true;
                this.studentId = studentId;
            }
        },
        signout() {
            const data = {
                signoutLetter: this.signoutLetter,
            };
            this.axios
                .delete(this.routes.internshipDeleteStudent(this.studentId, this.internshipIn.id), { data: data })
                .then(
                    (response) => {
                        this.alert.success();
                        this.$emit('signout', this.studentId);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
    },
};
</script>

<style scoped lang="scss">
.sidebar {
    margin-bottom: $grid-gutter-width;
}

.internships {
    .internship-item {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .internship-card {
            &.closed {
                filter: grayscale(1);
            }
        }
    }
}

.internship-show-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    > .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }
}

.not-found {
    margin-top: #{3 * map-get($grid-gutter-spacing, 'twenty-one')};
}
</style>
